import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const updateSelectedDate = (date: Types.SelectedDate) =>
  ({type: Constants.NEWSLETTER_COUNTS_UPDATE_SELECTED_DATE, date})

export const fetchNewsbriefs = (community: string, date: Types.SelectedDate) =>
  Request.requestActionCreator(Constants.FETCH_NEWSBRIEF_COUNTS)
  ({
    method: 'GET',
    payload: {selectedDate: date},
    url: `${Constants.SERVER_RESOURCE}/date/${date}${community !== '' ? '/' + community : ''}`,
  })

export const submitIssue = (community: string, issueId: number) =>
  Request.requestActionCreator<any>(Constants.RESUBMIT_ISSUE)
  ({
    method: 'POST',
    payload: {
      status: 'submit',
    },
    url: `${Constants.GENERATE_NEWSBRIEF_RESOURCE}/${community}/issue/${issueId}`,
  })

export const cancelIssue = (community: string, issueId: number) =>
  Request.requestActionCreator<any>(Constants.CANCEL_ISSUE)
  ({
    method: 'POST',
    payload: {
      status: 'cancel',
    },
    url: `${Constants.GENERATE_NEWSBRIEF_RESOURCE}/${community}/issue/${issueId}`,
  })



// WEBPACK FOOTER //
// ./src/pages/newsbrief-counts/actions.ts